import { Box, Button, Checkbox, Grid, Modal, Typography } from '@mui/material';
import AppTextField from 'components/input-fields/AppTextField';
import { useState } from 'react';
import { ChevronLeft } from 'react-feather';

export default function UserEditModal({
  showModal,
  setShowModal,
  userData = {},
}) {
  const [name, setName] = useState(userData?.name || '이가람');
  const [nickname, setNickname] = useState(
    userData?.nickname || '람쥐썬더3565'
  );
  const [phone, setPhone] = useState(userData?.phone || '+82 10-408-6005');
  const [email, setEmail] = useState(
    userData?.email || 'fkawnlTjsej123@gmail.com'
  );
  const [cardNewsCount, setCardNewsCount] = useState(
    userData?.cardNewsCount || '0'
  );
  const [membership, setMembership] = useState(
    userData?.membership || '브론즈'
  );

  // 글보기 멤버쉽 권한 (View Post Membership Permissions)
  const [viewReadStage1, setViewReadStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [viewReadStage2, setViewReadStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });

  // 글쓰기 멤버쉽 권한 (Write Post Membership Permissions)
  const [writePostStage1, setWritePostStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [writePostStage2, setWritePostStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });

  // 댓글 쓰기 멤버쉽 권한 (Write Comment Membership Permissions)
  const [writeCommentStage1, setWriteCommentStage1] = useState({
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5: false,
    termNnn: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [writeCommentStage2, setWriteCommentStage2] = useState({
    level0: false,
    level1: false,
    level2: false,
    level3: false,
    level4: false,
    level5: false,
    level6: false,
    manager: false,
    admin: false,
    master: false,
  });
  const [managerPermission, setManagerPermission] = useState(
    userData?.managerPermission || false
  );
  const [fullTimeManagerPermission, setFullTimeManagerPermission] = useState(
    userData?.fullTimeManagerPermission || true
  );
  const [accountDeactivate, setAccountDeactivate] = useState(
    userData?.accountDeactivate || false
  );
  const [selectedFile, setSelectedFile] = useState(null);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxWidth: '90vw',
    bgcolor: '#FFFFFF',
    borderRadius: '18px',
    boxShadow: 24,
    maxHeight: '90vh',
    overflowY: 'auto',
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
    }
  };

  const handleSubmit = () => {
    // Handle form submission logic here
    console.log({
      name,
      nickname,
      phone,
      email,
      cardNewsCount,
      membership,
      viewReadStage1,
      viewReadStage2,
      writePostStage1,
      writePostStage2,
      writeCommentStage1,
      writeCommentStage2,
      managerPermission,
      fullTimeManagerPermission,
      accountDeactivate,
      selectedFile,
    });
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      aria-labelledby="user-edit-modal"
      aria-describedby="user-edit-modal-description"
    >
      <Box sx={modalStyle}>
        {/* Header */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5,
            px: 4,
            borderBottom: '1px solid #F0F2F5',
            backgroundColor: '#FFFFFF',
            zIndex: 10,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              onClick={() => setShowModal(false)}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ChevronLeft size={24} color="#000000" />
            </Box>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 600,
                color: '#000000',
              }}
            >
              {name} 정보
            </Typography>
          </Box>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: '#3366FF',
              color: '#FFFFFF',
              height: 40,
              px: 3,
              borderRadius: 1.5,
              fontSize: 15,
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#2952CC',
                boxShadow: 'none',
              },
            }}
          >
            저장
          </Button>
        </Box>

        <Box sx={{ px: 4, pb: 4, pt: 3 }}>
          <Grid container spacing={3}>
            {/* 이름 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1,
                }}
              >
                이름
              </Typography>
              <AppTextField
                fullWidth
                name="name"
                placeholder="이름을 입력해 주세요"
                value={name}
                onChange={e => setName(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 닉네임 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1,
                }}
              >
                닉네임
              </Typography>
              <AppTextField
                fullWidth
                name="nickname"
                placeholder="닉네임을 입력해 주세요"
                value={nickname}
                onChange={e => setNickname(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 전화번호 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1,
                }}
              >
                전화번호
              </Typography>
              <AppTextField
                fullWidth
                name="phone"
                placeholder="전화번호를 입력해 주세요"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 이메일 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1,
                }}
              >
                이메일
              </Typography>
              <AppTextField
                fullWidth
                name="email"
                placeholder="이메일을 입력해 주세요"
                value={email}
                onChange={e => setEmail(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 카드뉴스 참여 횟수 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1,
                }}
              >
                카드뉴스 참여 횟수
              </Typography>
              <AppTextField
                fullWidth
                name="cardNewsCount"
                placeholder="참여 횟수를 입력해 주세요"
                value={cardNewsCount}
                onChange={e => setCardNewsCount(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F0F2F5',
                    borderRadius: '12px',
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3366FF',
                      borderWidth: 1,
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: 15,
                    color: '#333333',
                  },
                  '& .MuiOutlinedInput-input::placeholder': {
                    fontWeight: 400,
                    fontSize: 15,
                    color: '#999999',
                  },
                }}
                inputProps={{ style: { height: 18 } }}
              />
            </Grid>

            {/* 고객 멤버십 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 2,
                }}
              >
                고객 멤버쉽
              </Typography>

              {/* 1. 글보기 멤버쉽 권한 */}
              <Box sx={{ mb: 4 }}>
                {/* 글보기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글보기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setViewReadStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={viewReadStage1[item.key]}
                          onChange={e =>
                            setViewReadStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 글보기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글보기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setViewReadStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={viewReadStage2[item.key]}
                          onChange={e =>
                            setViewReadStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* 2. 글쓰기 멤버쉽 권한 */}
              <Box sx={{ mb: 4 }}>
                <Box
                  sx={{
                    height: '1px',
                    backgroundColor: '#E0E0E0',
                    mb: 3,
                  }}
                />

                {/* 글쓰기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글쓰기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWritePostStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writePostStage1[item.key]}
                          onChange={e =>
                            setWritePostStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 글쓰기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    글쓰기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWritePostStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writePostStage2[item.key]}
                          onChange={e =>
                            setWritePostStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* 3. 댓글 쓰기 멤버쉽 권한 */}
              <Box>
                <Box
                  sx={{
                    height: '1px',
                    backgroundColor: '#E0E0E0',
                    mb: 3,
                  }}
                />

                {/* 댓글 쓰기 멤버쉽 권한 1단계 */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    댓글 쓰기 멤버쉽 권한 1단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'all', label: '전체' },
                      { key: 'term1', label: '1기' },
                      { key: 'term2', label: '2기' },
                      { key: 'term3', label: '3기' },
                      { key: 'term4', label: '4기' },
                      { key: 'term5', label: '5기' },
                      { key: 'termNnn', label: 'nnn기' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWriteCommentStage1(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writeCommentStage1[item.key]}
                          onChange={e =>
                            setWriteCommentStage1(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* 댓글 쓰기 멤버쉽 권한 2단계 */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#333333',
                      mb: 1.5,
                    }}
                  >
                    댓글 쓰기 멤버쉽 권한 2단계
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 2,
                      flexWrap: 'wrap',
                    }}
                  >
                    {[
                      { key: 'level0', label: '레벨0' },
                      { key: 'level1', label: '레벨1' },
                      { key: 'level2', label: '레벨2' },
                      { key: 'level3', label: '레벨3' },
                      { key: 'level4', label: '레벨4' },
                      { key: 'level5', label: '레벨5' },
                      { key: 'level6', label: '레벨6' },
                      { key: 'manager', label: '매니저' },
                      { key: 'admin', label: '관리자' },
                      { key: 'master', label: '마스터' },
                    ].map(item => (
                      <Box
                        key={item.key}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setWriteCommentStage2(prev => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      >
                        <Checkbox
                          checked={writeCommentStage2[item.key]}
                          onChange={e =>
                            setWriteCommentStage2(prev => ({
                              ...prev,
                              [item.key]: e.target.checked,
                            }))
                          }
                          sx={{
                            color: '#D0D5DD',
                            padding: 0,
                            '&.Mui-checked': {
                              color: '#3366FF',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: 14, color: '#333333' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* 계정 설정 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 1.5,
                }}
              >
                계정 설정
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 3,
                  flexWrap: 'wrap',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setManagerPermission(!managerPermission)}
                >
                  <Checkbox
                    checked={managerPermission}
                    onChange={e => setManagerPermission(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    매니저 권한 부여
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    setFullTimeManagerPermission(!fullTimeManagerPermission)
                  }
                >
                  <Checkbox
                    checked={fullTimeManagerPermission}
                    onChange={e =>
                      setFullTimeManagerPermission(e.target.checked)
                    }
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    정직원 매니저 권한 부여
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setAccountDeactivate(!accountDeactivate)}
                >
                  <Checkbox
                    checked={accountDeactivate}
                    onChange={e => setAccountDeactivate(e.target.checked)}
                    sx={{
                      color: '#D0D5DD',
                      padding: 0,
                      '&.Mui-checked': {
                        color: '#3366FF',
                      },
                    }}
                  />
                  <Typography sx={{ fontSize: 15, color: '#333333' }}>
                    계정 비활성화
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* 크레탑 PDF 첨부 */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#333333',
                  mb: 0.5,
                }}
              >
                크레탑 PDF 첨부 (선택)
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#999999',
                  mb: 1.5,
                }}
              >
                .pdf 파일 1개 (100mb) 업로드 가능
              </Typography>
              <Box
                sx={{
                  backgroundColor: '#F0F2F5',
                  borderRadius: '12px',
                  px: 2,
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  minHeight: 52,
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    color: '#666666',
                    flex: 1,
                  }}
                >
                  {selectedFile ? selectedFile.name : '선택된 파일 없음'}
                </Typography>
                <Button
                  component="label"
                  variant="outlined"
                  sx={{
                    backgroundColor: '#FFFFFF',
                    color: '#666666',
                    borderColor: 'transparent',
                    height: 40,
                    px: 3,
                    borderRadius: '8px',
                    fontSize: 15,
                    fontWeight: 500,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    minWidth: 'auto',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                      borderColor: 'transparent',
                    },
                  }}
                >
                  파일 선택
                  <input
                    type="file"
                    hidden
                    accept=".pdf"
                    onChange={handleFileChange}
                  />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}
